import { useEffect, useState } from "react";
import { _Inbox, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { ThirdBankingAccountEditor } from "../../../../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBanking.editor";
import { _SupplierPaymentOrder } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectorRPBudgetContract } from "../../../../../contract/etapa-contrato/contrac/adquisitionContractRP/SelectorRPBudgetContract";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { Modal } from "../../../../../theme/Component/Modal";
import { ObjectDinamicViewer } from "../../../../../contract/etapa-contrato/contrac/ublinvoice/FireElectronicDocument/ObjectDinamicViewer/ObjectDinamicViewer";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { SelectSupplierPaymentTypeConstants } from "../../../../../contract/etapa-contrato/contrac/UBLInvoiceSupplier/Component/SelectSupplierPaymentTypeConstants";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const SOP012 = ({ configProcedure }: Props) => {

    const { instance, bean, setBean, lista, setLista, update, handleChange } = useDataBean(_SupplierPaymentOrder);
    const [addBudget, setAddBudget] = useState<boolean>(true);
    const [contract, setContract] = useState<any>({})
    const [infContrac, setInfContrac] = useState<any>({})

    const [modalSee, setModalSee] = useState<any>({ name: 'Contrato', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    useEffect(() => {
        typeUpdateItem()
        if (configProcedure?._pocessData?.Props) {
            setContract(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    useEffect(() => {
        if (contract.IDAdquisitionContract) {
            getAdquisitionContrac(contract.IDAdquisitionContract)
            setBean({
                Type: 2,
                IDAdquisitionContract: contract.IDAdquisitionContract,
                AdquisitionContractDate: contract.ContractSeleccionDate,
                IDEmployee: _single.getAccountID(),
                SupplierPaymentOrderDate: _single.getCurrenDate(),
                PaymentType:"PAGO PARCIAL"
            });
        }
    }, [contract])

    const typeUpdateItem = () => {
        instance.useBudget(null).then(
            (resp) => {
                setAddBudget(resp)
            }
        ).catch(
            err => {
                console.log(err)
                toast.error(err)
            }
        )
    }

    const getAdquisitionContrac = (idContrac) => {
        instance.getAdquisitionContractRender(1, 1, { "IDAdquisitionContract": idContrac }, null, null).then(
            (resp) => {
                if (resp.length > 0) {
                    const contrato = resp[0].DataBeanProperties;
                    setInfContrac(contrato);
                }
            }
        ).catch(
            err => {
                console.log(err)
            }
        )
    }

    const onExportMap = (OP, resumen) => {
        let PaymentO = {
            SupplierPaymentOrderDate: OP.SupplierPaymentOrderDate,
            IDSupplierPaymentOrder: OP.IDSupplierPaymentOrder,
            RPIDDocument: OP.RPIDDocument,
            RPDocumentDate: OP.RPDocumentDate,
            IDThirdBankingAccount: OP.IDThirdBankingAccount,
            Description: OP.Description
        }

        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(resumen)
        }

        if (configProcedure?._pushProps) {
            configProcedure?._pushProps(PaymentO)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(bean)
        }

        toast.success(`Se ha creado la Orden de Pago`)
    }

    const editaItem = () => {
        const table = {
            Valor_Contrato: infContrac.ContractAmount,
            Nit: infContrac.Nit,
            Proveedor: infContrac.Name1,
            Objecto: infContrac.Description,
            Fecha_Registro: bean.SupplierPaymentOrderDate,
            Valor_Orden: bean.ValorPago,
            Tipo_Pago: bean.PaymentType,
            // "Registro Presupuestal":`RP-${bean.RPIDDocument}`,
            Justificacion: bean.Description
        }
        const t = _single.jsonToBootstrapTable(table);
        console.log();
        if (configProcedure?._exportMap) {
            onExportMap(bean, t);
        }

    }

    const head = [
        { title: 'ID', property: 'IDAdquisitionContract', visible: false },
        { title: 'Valor Contrato', property: 'ContractValue', visible: true },
        { title: 'Fecha Contrato', property: 'ContractSeleccionDate', visible: true },
        { title: 'Código contrato', property: 'InternalCode', visible: true },
        { title: 'Proveedor', property: 'ContractName1', visible: true },
        { title: 'Descripción', property: 'ContractDescription', visible: true },
    ]

    return (
        <>
            <div className="row">
                <div className="col-md-6">
                    <strong>No. Contrato </strong><small>{infContrac.InternalCode}</small>
                </div>
                <div className="col-md-6">
                    <strong>Valor del Contrato: </strong><small>{_single.formatMoney(infContrac.ContractAmount)}</small>
                </div>
                <div className="col-md-4">
                    <strong>Identificación: </strong><small>{infContrac.Nit}</small>
                </div>
                <div className="col-md-8">
                    <strong>Proveedor: </strong><small>{infContrac.Name1}</small>
                </div>
                <div className="col-md-6">
                    <strong>Fecha del Contrato: </strong><small>{infContrac.AdquisitionContractDate}</small>
                </div>
                <div className="col-md-12">
                    <p>
                        <strong>Objecto:</strong><br />
                        {infContrac.Description}
                    </p>
                </div>
                {/* <div className="col-md-12">
                    <PrintJson json={infContrac} />
                </div> */}
            </div>
            <div className="row">
                <div className="col-md-6">
                    <label>Fecha de Registro de la Orden de Pago</label>
                    <InputDate name=" " value={bean.SupplierPaymentOrderDate} setDate={(e) => { setBean({ ...bean, "SupplierPaymentOrderDate": e }) }} />
                </div>
                <div className="col-md-6">
                    <label>Valor Pago</label>
                    <input type="number" className="form-control" value={bean.ValorPago} onChange={(e) => { setBean({ ...bean, "ValorPago": e.target.value }) }} />
                </div>
                <div className="col-md-6">
                    <ThirdBankingAccountEditor label="Cuenta Bancaria del Tercero" idSelector={bean.IDThirdBankingAccount} idselectorAccount={contract.IDAccountSupplier} onChange={(e) => { setBean({ ...bean, "IDThirdBankingAccount": e }) }} />
                </div>
                <div className="col-md-6">
                    <label>Tipo de Pago</label>
                    <select className="form-select" value={bean.PaymentType} onChange={(e) => { setBean({ ...bean, "PaymentType": e.target.value }) }}>                        
                        <option value="PAGO PARCIAL">PAGO PARCIAL</option>
                        <option value="PAGO TOTAL">PAGO TOTAL</option>
                    </select>
                    {/* <input type="text" className="form-control" value={bean.PaymentType} onChange={(e) => { setBean({ ...bean, "PaymentType": e.target.value }) }} /> */}
                </div>
                    {/* {bean.SupplierPaymentOrderDate &&
                        <div className="col-md-6">
                            <SelectorRPBudgetContract paymentDate={bean.SupplierPaymentOrderDate} adquisitionContract={contract} onChange={(e) => { setBean({ ...bean, "RPIDDocument": e.IDDocument, "RPDocumentDate": e.DocumentDate,"RPConsecutive":e.Consecutive }) }} label="Registro Presupuestal" />
                        </div>
                    } */}
                <div className="col-md-12">
                    <label>Justificación del Pago</label>
                    <textarea name="Description" className="form-control" rows={5} value={bean.Description} onChange={handleChange} />
                </div>

                <div className="col-md-12 mt-4">
                    <div className="row">
                        <div className="col-md-6">
                            <BasicButton eventClick={editaItem} icon="ri-save-line" children={"Registrar Solicitud"} />
                        </div>
                    </div>
                </div>

                {/* <div className="col-md-12">
                    <Modal modal={modalSee} updateModal={setModalSee} >
                        <div className="row">
                            <div className="col-md-12">
                                <ObjectDinamicViewer data={contract} head={head} />
                            </div>
                        </div>
                    </Modal>
                </div > */}
            </div >
        </>
    )
}